'use strict';

/* globals angular */

require('./myProfile');
require('./changePassword');
// require('./account');
// require('./access');
require('./orgBilling');
require('./orgSites');
require('./orgUsers');
require('./dataStores');

var DropdownDirective = require('./directives/DropdownDirective');
var FocusOnEditDirective = require('./directives/FocusOnEditDirective');
var SearchDirective = require('./directives/SearchDirective');
var SpinnerDirective = require('./directives/SpinnerDirective');

var StatusFilter = require('./filters/StatusFilter');
var SettingsController = require('./SettingsController');
var SettingsRoutes = require('./SettingsRoutes');
var SettingsService = require('./SettingsService');

angular.module('settings', [
  'settings.myProfile',
  'settings.changePassword',
  // 'settings.account',
  // 'settings.access',
  'settings.orgBilling',
  'settings.orgSites',
  'settings.orgUsers',
  'settings.organizationStore'
])

// Routing
.config(SettingsRoutes)

// Main Controller
.controller('SettingsController', SettingsController)

// Directives
.directive('search', SearchDirective)
.directive('dropdown', DropdownDirective)
.directive('focusOnEdit', FocusOnEditDirective)
.directive('settingsSpinner', SpinnerDirective)

// Flux Actions and Store
.factory('SettingsActions', require('./SettingsActions'))
.factory('SettingsStore', require('./SettingsStore'))

// Filters
.filter('status', StatusFilter)

// Services
.service('SettingsService', SettingsService)

// Bind store to actions through init method
.run(['SettingsStore', function (SettingsStore) {
  SettingsStore.init();
}]);



// WEBPACK FOOTER //
// ./src/app/settings/index.js